(() => {
  "use strict";

  if (window.GR_EXPOSITORES_V2_CART_LOADED) return;
  window.GR_EXPOSITORES_V2_CART_LOADED = true;

  const CONTRACT_VERSION = "2";
  const PARENT_ROLE = "parent";
  const COMPONENT_ROLE = "component";

  const endpointWithJsonExtension = (url, fallback) => {
    const endpoint = new URL(typeof url === "string" && url ? url : fallback, window.location.origin);
    endpoint.pathname = `${endpoint.pathname.replace(/\/$/, "").replace(/\.js$/, "")}.js`;
    return `${endpoint.pathname}${endpoint.search}`;
  };

  const readProperty = (item, name) => {
    if (!item || !item.properties || typeof item.properties !== "object") return undefined;
    return Object.prototype.hasOwnProperty.call(item.properties, name)
      ? item.properties[name]
      : undefined;
  };

  const fetchJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: "same-origin",
      ...options,
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        ...(options.headers || {}),
      },
    });

    const payload = await response.json().catch(() => {
      throw new Error("Shopify devolvió una respuesta no válida.");
    });

    if (!response.ok || payload?.status || payload?.errors) {
      throw new Error(
        payload?.description ||
          payload?.message ||
          "No se pudo actualizar el carrito. Inténtalo de nuevo."
      );
    }

    return payload;
  };

  const verifiedGroupKeys = (cart, groupId) => {
    if (!cart || !Array.isArray(cart.items) || typeof groupId !== "string" || !groupId) {
      throw new Error("No se pudo verificar esta configuración. Actualiza el carrito e inténtalo de nuevo.");
    }

    const groupItems = cart.items.filter(
      (item) =>
        readProperty(item, "_expositor_contract_version") === CONTRACT_VERSION &&
        readProperty(item, "_expositor_group_id") === groupId
    );

    let parentCount = 0;
    let componentCount = 0;
    const keys = [];

    groupItems.forEach((item) => {
      const role = readProperty(item, "_expositor_role");
      if (role === PARENT_ROLE) {
        parentCount += 1;
      } else if (role === COMPONENT_ROLE) {
        componentCount += 1;
      } else {
        throw new Error("La configuración ha cambiado y no se puede eliminar de forma segura. Actualiza el carrito.");
      }

      if (typeof item.key !== "string" || !item.key) {
        throw new Error("Falta un identificador de producto. Actualiza el carrito antes de eliminar la configuración.");
      }
      keys.push(item.key);
    });

    if (parentCount !== 1 || componentCount < 1) {
      throw new Error("La configuración está incompleta. Actualiza el carrito antes de eliminarla.");
    }

    if (new Set(keys).size !== keys.length) {
      throw new Error("La configuración contiene identificadores duplicados y no se puede eliminar de forma segura.");
    }

    return keys;
  };

  const sectionsForDrawer = (drawer) => {
    if (!drawer || typeof drawer.getSectionsToRender !== "function") return [];

    const sections = drawer.getSectionsToRender();
    if (!Array.isArray(sections)) return [];

    return [
      ...new Set(
        sections
          .map((section) => section?.section || section?.id)
          .filter((sectionId) => typeof sectionId === "string" && sectionId)
      ),
    ];
  };

  const showError = (group, message) => {
    const error = group?.querySelector("[data-expositores-v2-group-error]");
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  };

  const clearError = (group) => {
    const error = group?.querySelector("[data-expositores-v2-group-error]");
    if (!error) return;
    error.textContent = "";
    error.hidden = true;
  };

  const removeVerifiedGroup = async (button) => {
    const group = button.closest("[data-expositores-v2-cart-group]");
    const groupId = button.getAttribute("data-expositor-group-id");
    if (!group || typeof groupId !== "string" || !groupId || button.disabled) return;

    const drawer = group.closest("cart-drawer");
    const cartUrl = endpointWithJsonExtension(window.routes?.cart_url, "/cart");
    const updateUrl = endpointWithJsonExtension(window.routes?.cart_update_url, "/cart/update");

    clearError(group);
    button.disabled = true;
    button.setAttribute("aria-disabled", "true");
    button.classList.add("is-loading");
    group.setAttribute("aria-busy", "true");

    try {
      const currentCart = await fetchJson(cartUrl);
      const keys = verifiedGroupKeys(currentCart, groupId);
      const updates = Object.fromEntries(keys.map((key) => [key, 0]));
      const sectionIds = sectionsForDrawer(drawer);
      const requestBody = { updates };

      if (drawer && sectionIds.length) {
        requestBody.sections = sectionIds;
        requestBody.sections_url = window.location.pathname;
      }

      const updatedCart = await fetchJson(updateUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      if (
        drawer &&
        typeof drawer.renderContents === "function" &&
        updatedCart.sections &&
        typeof updatedCart.sections === "object"
      ) {
        try {
          drawer.renderContents(updatedCart);
          document.dispatchEvent(
            new CustomEvent("expositores:v2:group-removed", {
              detail: { cart: updatedCart, groupId },
            })
          );
          return;
        } catch (renderError) {
          console.error(renderError);
        }
      }

      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.removeAttribute("aria-disabled");
      button.classList.remove("is-loading");
      group.removeAttribute("aria-busy");
      showError(
        group,
        error instanceof Error
          ? error.message
          : "No se pudo eliminar la configuración. Inténtalo de nuevo."
      );
    }
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-expositores-v2-remove-group]");
    if (!button) return;
    event.preventDefault();
    removeVerifiedGroup(button);
  });
})();
